<template>
  <section class='leaveStu' id='departlist'>
    <Row>
      <Breadcrumb>

        <BreadcrumbItem to="">权限管理</BreadcrumbItem>
        <BreadcrumbItem to="">单位配置</BreadcrumbItem>

      </Breadcrumb>
    </Row>
    <Row xs="20" sm="16" md="12" lg="8">

      <Col span='12'>
      <Alert show-icon type='error'>
        <Icon type="ios-bulb-outline" slot="icon"></Icon>
        创建单位/公司，APP根据单位邀请码添加相应人员，用于食堂消费等场景。
      </Alert>
      </Col>
      <ul class='conheadRight'>
        <i-button type="error" @click='sModal(-1)'>创建单位</i-button>
      </ul>
    </Row>
    <section class='tabelContent'>
      <tablePage border :queryData="queryData" :searchParam='searchParam' :issearch='issearch' @smodal='sModal'>
      </tablePage>
    </section>


    <bemodal :reloadtmp='reloadTmep' :formdata='formData' @reloadModalData='reloadTable'></bemodal>
    <Modal v-model="newConfig" title='人员配置' :mask-closable='false' width='462px'>

      <Form label-position="top" ref='formCustom'>
        <Transfer :data="alluser" :target-keys="targetUser" id='teachTransfer' filterable :not-found-text="''"
          :reverse-operation='true' :titles="['待选列表', '已选列表']" @on-change="changeUsers"></Transfer>
      </Form>

      <div slot="footer" style='position:relative;'>

        <Button type="default" @click='newConfig = false' icon="md-close">取消</Button>
        <Button type="info" @click='newConfigMethod' icon="md-checkmark-circle-outline">保存</Button>
        <!-- <Button type="primary" @click='pipeGw' icon="md-checkmark-circle-outline" v-if='targetKeys.length>0'>流转文件</Button> -->
      </div>
    </Modal>
    <Modal v-model='addMoney' width='600px' title='充值' @on-ok='updateLesson'>
      <Form :model="formItem" :label-width="100">
        <FormItem label="部门名称">
          <Input v-model="formItem.name" disabled placeholder=""></Input>
        </FormItem>
        <FormItem label="金额">
          <Input type='number' v-model="formItem.amount" placeholder=""></Input>
        </FormItem>
        <FormItem label="备注">
          <Input type='text' v-model="formItem.remark" placeholder=""></Input>
        </FormItem>
      </Form>
    </Modal>
  </section>
</template>

<script>
import tablePage from './tablePage'
import bemodal from './formItemNoSch'
export default {
  name: 'noticelist',
  components: {
    tablePage,
    bemodal,
  },
  data () {
    return {
      formItem: {
        name: '',
        amount: 0,
        departid: '',
        remark: '',
      },
      addMoney: false,
      curRowGuid: -1,
      alluser: [],
      targetUser: [],
      newConfig: false,
      smodal: false,
      reloadTmep: -1,
      curSchoolid: -1,
      initformData: [],
      formData: [
        ['dic/getId', 'dic/addDepart', 'dic/delete'],
        [
          {
            type: 'input',
            title: '单位名称',
            name: 'name',
            model: '',
          },
          {
            type: 'input',
            title: '排序',
            name: 'sort',
            model: '',
          },
          {
            type: 'textarea',
            title: '备注',
            name: 'remark',
            model: '',
          },
          {
            type: 'uploadimg',
            title: '封面',
            name: 'icon',
            pictype: {
              type: 'gallery',
              size: ''
            },
            model: '',
          },
          {
            type: 'hidden',
            children: [{
              name: 'guid',
              model: ''
            }, {
              name: 'rootid',
              model: 'depart'
            }]
          }
        ]
      ],
      queryData: ['dic/getQueryList?sort=999&pid=0&rootid=depart',
        [{
          title: '封面',
          key: '',
          render: (h, params) => {

            return h('viewer', [
              h('img', {
                style: {//设置样式
                  display: 'inline-block',
                  width: '49px',
                  height: '27px',
                },
                attrs: {//设置属性
                  src: params.row.icon
                }
              })]
            )
          }

        }, {
          title: '单位名称',
          key: 'name',
          render: (h, params) => {
            return h('strong', decodeURI(params.row.name))
          }
        },
        {
          title: '邀请码',
          key: 'remark',
        },
        {
          title: '排序',
          key: 'sort',
        },
        //   {
        // 	title: '操作',
        // 	key: '',
        // 	align: 'center',
        // 	width:'230px',
        // 	render: (h, params) => {
        // 		 return h('div', [
        // 				h('span', {
        // 					style: {

        // 						textDecoration:'underline',
        // 						color:'#fa5c7c',
        // 						cursor:'pointer'
        // 					},
        // 					on: {
        // 						click: () => {
        // 							this.addMoney = true
        // 							console.log(params)
        // 							this.formItem.name = params.row.name
        // 							this.formItem.departid = params.row.guid

        // 						}
        // 					}
        // 				}, '批量充值')
        // 			]);
        // 	}
        // },
        {
          title: '操作',
          slot: 'action',
          width: 110,
          align: 'center'
        }

        ]
      ],
      searchParam: {
        notice: '',
      },
      issearch: -1,
    }
  },
  mounted () {
    this.initformData = JSON.parse(JSON.stringify(this.formData[1]))
    // var userInfo = JSON.parse(localStorage.getItem('inchUserinfo'))
    // this.curSchoolid  = userInfo.schoolid
    // this.getMember(userInfo.schoolid)
  },
  methods: {
    updateLesson () {
      console.log(this.formItem)
      var that = this
      if (this.formItem.amount != 0) {

        this.axios.post('canteenAmountRecord/saveBatch', this.formItem).then((a) => {
          if (a.success) {
            that.$Message.info(a.msg)
            that.issearch = Math.random()
            that.formItem = {
              name: '',
              remark: '',
              departid: '',
              amount: 0,

            }
          } else {
            that.$Message.info(a.msg)
            that.issearch = Math.random()
          }
        })
      }

    },
    searchData () {
      this.issearch = Math.random()
    },
    sModal (guid, item) {
      console.log(guid, 'guid', item)
      this.reloadTmep = Math.random()
      if (this.formData[0][0].indexOf('?') > -1) {
        this.formData[0][0] = this.formData[0][0].split('?')[0]
      }
      var _id = guid ? guid : item.id
      this.formData[0][0] = this.formData[0][0] + '?id=' + _id
      if (_id == -1) {
        this.formData[1] = JSON.parse(JSON.stringify(this.initformData))
      }
    },
    reloadTable () {
      this.issearch = Math.random()
    },
    changeUsers (val, c, d) {
      this.targetUser = val
    },
    newConfigMethod () {

      var that = this
      var param = {
        id: this.curRowGuid,
        userid: this.targetUser.join(','),
        schoolid: this.curSchoolid
      }
      console.log(param)

      this.axios.post('webUser/addDepartUser', param).then(res => {
        console.log(res)
        if (res.success) {
          that.newConfig = false
        }
      })
    },
    getMember (schoolid) {
      var that = this
      that.axios.post('sys/getTeachBySchool2', {}).then((a) => {
        console.log(a)
        a.map(function (val, index) {
          val['label'] = val['name']
          val['key'] = val['id']
        })
        that.alluser = a
      })
    },
  }
}
</script>

<style scoped>
.tabelContent {
  margin-top: 20px;
}

.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  /* overflow: scroll; */
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 5px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
}

.demo-upload-list {
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  overflow: hidden;
  margin-right: 4px;
  margin-bottom: 5px;
}

.demo-upload-list img {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 15px;
}

.demo-upload-list span {
  line-height: 40px;
  font-size: 12px;
  float: left;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
  line-height: 40px;

}

#departlist #hwSchool {
  position: relative;
}

#departlist #hwSchool .ivu-tree {
  position: absolute;
  top: 33px;
  left: 0px;
  background: #fff;
  z-index: 1000;
  width: 300px;
  height: 300px;
  border: 1px solid #dcdee2;
  border-top: 0 none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
}

.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.treeContent {}

.hwImgCon {
  margin-top: 10px;

}

.hwImgCon img {
  width: 55px;
  height: 55px;
  border-radius: 5px;
}

#departlist .conheadRight {
  float: right;
  margin-right: 10px;
}

#teachTransfer {
  height: 350px;
}
</style>
